import React, { useEffect, useContext, useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'

import download_interface_cream from 'img/document-icons/download-interface-cream.svg'

import {
	BoxInfoSuccessCheckmark,
	getErrorWithFullMessage,
	isSafariBrowser,
} from 'shared'

import SspContext from 'selfServicePortal/contexts/SspContext'
import sddService from 'selfServicePortal/services/CreditCardServices/sddService'
import { SddDispatchContext, SDD_ACTIONS } from '../SDDMultistepValues'

export const SDDSuccessResponse = () => {
	const [sdd, dispatchSdd] = useContext(SddDispatchContext)
	const { setSddRefreshData } = useContext(SspContext)
	const [error, setError] = useState<any>()

	const { t } = useTranslation()

	useEffect(() => {
		dispatchSdd({
			type: SDD_ACTIONS.SET_DESCRIPTION,
			payload: {
				description: '',
			},
		})
	}, [dispatchSdd])

	const getSddMandateDocument = useCallback(
		async (mandateDocumentId: string, windowRef: Window | null) => {
			try {
				await sddService.getSddMandateDocument(
					mandateDocumentId,
					windowRef,
				)
			} catch (error: any) {
				setError(getErrorWithFullMessage(error))
				console.warn(error)
			}
		},
		[],
	)

	return (
		<div className="sdd-success-response">
			<BoxInfoSuccessCheckmark
				css={'sdd-success-box success-msg-checkmark-animation'}
				message={
					<>
						<div className="sdd-success-message">
							{t('SDDEnrolledSuccessMsg')}
						</div>
						<button
							type="button"
							className="btn btn-primary download-mandate-btn"
							onClick={() => {
								let windowRef = isSafariBrowser()
									? window.open()
									: null
								getSddMandateDocument(
									sdd.mandateDocumentId,
									windowRef,
								)
							}}>
							<span>{t('SDDDownloadMandate')}</span>

							<img
								src={download_interface_cream}
								className="download-icon-cream"
								alt="download icon"
							/>
						</button>
					</>
				}
			/>
			{error && (
				<div className="error-msg">{t('ErrorAccountStatements')}</div>
			)}
			<div className="back-section">
				<button
					type="button"
					className="btn btn-outline dark-gray back-btn"
					onClick={() => setSddRefreshData(true)}>
					{t('Back')}
				</button>
			</div>
		</div>
	)
}
